import { File } from '../common/file.model';
import { ModelMixin } from '../core/base-generic.model';
import { Applicant } from './applicant.model';
import { JobAttachment } from './job-attachments.model';
import { JobPosting } from './job-posting.model';

export class ApplicantAttachment extends ModelMixin<ApplicantAttachment>() {
    protected static _resource = 'applicantTracker/applicantAttachments';
    protected static _version = 'v2';

    protected static _datetimes = ['createdAt', 'updatedAt', 'deletedAt'];

    protected static _serializeAttributes = ['applicantId', 'jobAttachmentId', 'fileId', 'content', 'name'];

    get name(): string | undefined {
        return this._attributes['name'];
    }

    set name(val: string) {
        this._attributes['name'] = val;
    }

    get applicantId(): number {
        return this._attributes['applicantId'];
    }

    set applicantId(val: number) {
        this._attributes['applicantId'] = val;
    }

    get jobAttachmentId(): number {
        return this._attributes['jobAttachmentId'];
    }

    set jobAttachmentId(val: number) {
        this._attributes['jobAttachmentId'] = val;
    }

    get fileId(): number {
        return this._attributes['fileId'];
    }

    set fileId(val: number) {
        this._attributes['fileId'] = val;
    }

    get convertedFileId(): number {
        return this._attributes['convertedFileId'];
    }

    set convertedFileId(val: number) {
        this._attributes['convertedFileId'] = val;
    }

    get content(): string {
        return this._attributes['content'];
    }

    set content(val: string) {
        this._attributes['content'] = val;
    }

    get jobPosting(): JobPosting {
        return this.hasOne(JobPosting, 'jobPosting');
    }

    get jobAttachment(): JobAttachment {
        return this.hasOne(JobAttachment, 'jobAttachment');
    }

    set jobAttachment(val: JobAttachment) {
        this.setOne('jobAttachment', val);
    }

    get file(): File {
        return this.hasOne(File, 'file');
    }

    // We need to convert JobAttachments as they are only a indication of what files a user can upload but to actually save files we must save them as Applicant Attachments
    static convertJobAttachmentsToApplicantAttachments(
        jobAttachments: JobAttachment[],
        applicant: Applicant
    ): ApplicantAttachment[] {
        return jobAttachments.map((jobAttachment: JobAttachment) => {
            const applicantAttachment = new ApplicantAttachment({
                applicantId: applicant.id,
                jobAttachmentId: jobAttachment.id,
                fileId: jobAttachment.fileId ? jobAttachment.fileId : undefined,
                content: jobAttachment.link ? jobAttachment.link : undefined,
            });
            applicantAttachment.jobAttachment = jobAttachment;
            return applicantAttachment;
        });
    }
}
